import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { Content } from "antd/es/layout/layout";
import AppSiderProjectesId from "./menus/AppSiderProjectesId";
import { GetProjecteId } from "../../../dao/abp/GetProjecteId";
import ProjecteIdTasques from "./content/ProjecteIdTasques";
import ProjecteIdResum from "./content/ProjecteIdResum";
import ProjecteIdValidacions from "./content/ProjecteIdValidacions";
import { GetSprintsByProject } from "../../../dao/abp/GetSprintsByProject";

const ProjectesIdGrupIdAvaluacio = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const navigate = useNavigate();
    const { id_projecte, id_grup } = useParams();
    const [dades, setDades] = useState<any>(); // usage of setDades was weird in original, simplified
    const [pantalla, setPantalla] = useState(0);
    const [selectedUid, setSelectedUid] = useState('');
    const [sprints, setSprints] = useState<any[]>([]);
    const [selectedSprint, setSelectedSprint] = useState<any>();

    const [enviado, setEnviado] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_projecte]);

    async function checkDades() {
        setLoading(true);
        try {
            const data = await GetProjecteId(id_projecte + "", 0);
            let sprintsData = await GetSprintsByProject(id_projecte + "");

            if (data) {
                // Safety check for sprintsData
                if (!Array.isArray(sprintsData)) {
                    console.error("GetSprintsByProject returned non-array:", sprintsData);
                    sprintsData = [];
                }

                // Filter sprints for students based on visibility (legacy check, usually this view is for teachers)
                let filteredSprints = sprintsData;
                if (user.tipus === "2") {
                    filteredSprints = filteredSprints.filter((s: any) => s.puede_ver === 1);
                }

                setSprints(filteredSprints);

                setBreadCrumb([{ nom: 'Home', nav: '/home' },
                { nom: 'Avaluació', nav: '/abp' },
                { nom: 'Projectes', nav: '/abp/projectes' },
                { nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` },
                { nom: 'Grups', nav: `/abp/projectes/${data.id}` },
                { nom: `${id_grup}`, nav: `/abp/projectes/${data.id}/grups/${id_grup}` },
                { nom: 'Avaluació', nav: `/abp/projectes/${data.id}/grups/${id_grup}/avaluacio` }], true);

                setDades(data);
            }
        } catch (error) {
            console.error("Error checking dades:", error);
        } finally {
            setLoading(false);
        }
    }

    function setPnt(value: number, isSprint: boolean, sprint: string) {
        if (!isSprint) {
            setPantalla(value);
        } else {
            setSelectedSprint(sprints.find(value1 => {
                if (value1.id + "" === sprint + "") {
                    return value1;
                }
            }));
            setPantalla(1);
        }
    }


    if (isLoggedIn) {
        return (
            <>
                <AppSiderProjectesId setPantalla={setPnt} currentVal={0} sprints={sprints} />
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    {pantalla === 0 && <ProjecteIdResum />}
                    {pantalla === 1 && <ProjecteIdTasques sprint={selectedSprint} />}
                    {pantalla === 2 && <ProjecteIdValidacions />}
                </Content>
            </>
        );
    } else {
        return (
            <Login />
        );
    }
};

export default ProjectesIdGrupIdAvaluacio;
